module.exports = __webpack_public_path__ + "static/media/ruby.80a5e190.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/ruby.png
// module id = 181
// module chunks = 0